import { render, staticRenderFns } from "./deviceStatus.vue?vue&type=template&id=2cb5044a"
import script from "./deviceStatus.vue?vue&type=script&lang=js"
export * from "./deviceStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports